import React from 'react';
import { Outlet } from 'react-router';

const Admin = (props: any) => {
  return (
    <Outlet />
  );
};

export default Admin;
